import { privacyManagerOTTCCPAViews } from '../../constants';
const homeView = {
  type: 'CCPAPrivacyManagerOTT',
  name: 'Privacy Manager Home View',
  id: privacyManagerOTTCCPAViews.HOME,
  settings: {},
  children: []
};
const vendorsView = {
  type: 'CCPAPrivacyManagerOTTVendorsView',
  name: 'Privacy Manager Vendors View',
  id: privacyManagerOTTCCPAViews.VENDORS,
  settings: {},
  children: []
};
const preferencesDetails = {
  type: 'CCPAPrivacyManagerOTTPreferencesView',
  name: 'Privacy Manager Preferences View',
  id: privacyManagerOTTCCPAViews.CATEGORIES,
  settings: {},
  children: []
};
const privacyPolicy = {
  type: 'CCPAPrivacyManagerOTTPrivacyPolicyView',
  name: 'Privacy Manager Privacy Policy View',
  id: privacyManagerOTTCCPAViews.PRIVACY_POLICY,
  settings: {},
  children: []
};
const cardDetails = {
  type: 'CCPAPrivacyManagerOTTCardDetailsView',
  name: 'Vendor/Category Details View',
  id: privacyManagerOTTCCPAViews.CARD_DETAILS,
  settings: {},
  children: []
};
const customView = {
  type: 'CCPAPrivacyManagerOTTCustomView',
  name: 'Custom View',
  id: privacyManagerOTTCCPAViews.CUSTOM_VIEW,
  settings: {},
  children: []
};
export default [homeView, preferencesDetails, vendorsView, privacyPolicy, cardDetails, customView];